import { createSlice } from "@reduxjs/toolkit";

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    isLoading: false,
    isLoadingSketon: false,
    isLogin: false,
    employeeList: [],
    employmentInformation: {},
    employeeOptions: [],
    currentEmployee: {},
    currentContactInfo: {},
    familyList: [],
    workExperienceList: [],
    educationList: [],
    currentEmployment: {},
    currentEmploymentHome: {},
    shiftList: [],
    workScheduleCalendarList: [],
    leaveBenefitList: [],
    getLeaveBenefit: [],
    subOrdinatesList: [],
    supervisorList: [],
    workInLocationList: [],
    supervisorDetails: {},
    subOrdinateDetails: {},
    organizationStructure: [],
    departmentOptions: [],
    positionOptions: [],
    shiftOptions: [],
    workInLocationOptions: [],
    durationOptions: [],
    supervisorOptions: [],
    holidayCalendarOptions: [],
    occupationOptions: [],
    bankOptions: [],
    workIn: [],
    branchOptions: [],
    calendar: [],
    employeeListForTeam: [],
    movementList: [],
    remainingLeave: [],
    employeeWorkInCount: {},
    currentWorking: {},
    leaveonday: {},
    currentEmployeeOnEdit: {},
    currentContactInfoOnEdit: {},
    currentEmploymentInProfile: {},
    workinCalendarHome: [],
    employeeWelfareList: [],
    teamWorkingCount: {},
    teamWorkingDetail: [],
    teamVisaWorkPermit: [],
  },
  reducers: {

    setRelationship(state, action) {
      state.relationship = action.payload;
    },

    setOccupationOptions(state, action) {
      state.occupationOptions = action.payload;
    },
    setCurrentWorking(state, action) {
      state.currentWorking = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsLoadingSketon(state, action) {
      state.isLoadingSketon = action.payload;
    },
    setEmployeeList(state, action) {
      state.employeeList = action.payload;
    },
    employmentInformation(state, action) {
      state.employmentInformation = action.payload;
    },
    setEmployeeOptions(state, action) {
      state.employeeOptions = action.payload;
    },
    setCurrentEmployee(state, action) {
      state.currentEmployee = action.payload;
    },
    setCurrentContactInfo(state, action) {
      state.currentContactInfo = action.payload;
    },
    setFamilyList(state, action) {
      state.familyList = action.payload;
    },
    setWorkExperienceList(state, action) {
      state.workExperienceList = action.payload;
    },
    setEducationList(state, action) {
      state.educationList = action.payload;
    },
    setCurrentEmployment(state, action) {
      state.currentEmployment = action.payload;
    },
    setCurrentEmploymentHome(state, action) {
      state.currentEmploymentHome = action.payload;
    },
    setShiftList(state, action) {
      state.shiftList = action.payload;
    },
    setWorkScheduleCalendarList(state, action) {
      state.workScheduleCalendarList = action.payload;
    },
    setLeaveBenefitList(state, action) {
      state.leaveBenefitList = action.payload;
    },
    setGetLeaveBenefit(state, action) {
      state.getLeaveBenefit = action.payload;
    },
    setSubOrdinatesList(state, action) {
      state.subOrdinatesList = action.payload
    },
    setSupervisorList(state, action) {
      state.supervisorList = action.payload
    },
    setWorkInLocationList(state, action) {
      state.workInLocationList = action.payload
    },
    setSupervisorDetails(state, action) {
      state.supervisorDetails = action.payload
    },
    setSubOrdinateDetails(state, action) {
      state.subOrdinateDetails = action.payload
    },
    setOrganizationStructure(state, action) {
      state.organizationStructure = action.payload
    },
    setDepartmentOptions(state, action) {
      state.departmentOptions = action.payload
    },
    setPositionOptions(state, action) {
      state.positionOptions = action.payload
    },
    setShiftOptions(state, action) {
      state.shiftOptions = action.payload
    },
    setWorkInLocationOptions(state, action) {
      state.workInLocationOptions = action.payload
    },
    setDurationOptions(state, action) {
      state.durationOptions = action.payload
    },
    setSupervisorOptions(state, action) {
      state.supervisorOptions = action.payload
    },
    setHolidayCalendarOptions(state, action) {
      state.holidayCalendarOptions = action.payload
    },
    setBankOptions(state, action) {
      state.bankOptions = action.payload
    },
    setWorkIn(state, action) {
      state.workIn = action.payload
    },
    setCalendar(state, action) {
      state.calendar = action.payload
    },
    setEmployeeListForTeam(state, action) {
      state.employeeListForTeam = action.payload
    },
    setMovementList(state, action) {
      state.movementList = action.payload
    },
    setBranchOptions(state, action) {
      state.branchOptions = action.payload
    },
    setEmpRemainingLeave(state, action) {
      state.remainingLeave = action.payload;
    },
    setEmployeeWorkInCount(state, action) {
      state.employeeWorkInCount = action.payload;
    },
    setLeaveonday(state, action) {
      state.leaveonday = action.payload;
    },
    setCurrentEmployeeOnEdit(state, action) {
      state.currentEmployeeOnEdit = action.payload;
    },
    setCurrentContactInfoOnEdit(state, action) {
      state.currentContactInfoOnEdit = action.payload;
    },
    setCurrentEmploymentInProfile(state, action) {
      state.currentEmploymentInProfile = action.payload;
    },
    setWorkinCalendarHome(state, action) {
      state.workinCalendarHome = action.payload;
    },
    setEmployeeWelfareList(state, action) {
      state.employeeWelfareList = action.payload;
    },
    setTeamWorkingCount(state, action) {
      state.teamWorkingCount = action.payload;
    },
    setTeamWorkingDetail(state, action) {
      state.teamWorkingDetail = action.payload;
    },
    setTeamVisaWorkPermit: (state, action) => {
      state.teamVisaWorkPermit = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setEmployeeList,
  setEmployeeDropDown,
  setCurrentEmployee,
  setCurrentContactInfo,
  setFamilyList,
  setWorkExperienceList,
  setEducationList,
  setCurrentEmployment,
  setCurrentEmploymentHome,
  setShiftList,
  setWorkScheduleCalendarList,
  setLeaveBenefitList,
  setGetLeaveBenefit,
  setSubOrdinatesList,
  setSupervisorList,
  setWorkInLocationList,
  setSupervisorDetails,
  setSubOrdinateDetails,
  setOrganizationStructure,
  setEmployeeOptions,
  setDepartmentOptions,
  setPositionOptions,
  setIsLoadingSketon,
  setShiftOptions,
  setWorkInLocationOptions,
  setDurationOptions,
  setSupervisorOptions,
  setHolidayCalendarOptions,
  setOccupationOptions,
  setBankOptions,
  setWorkIn,
  setCalendar,
  setEmployeeListForTeam,
  setMovementList,
  setBranchOptions,
  setEmpRemainingLeave,
  setEmployeeWorkInCount,
  setCurrentWorking,
  setLeaveonday,
  setCurrentEmployeeOnEdit,
  setCurrentContactInfoOnEdit,
  setCurrentEmploymentInProfile,
  setWorkinCalendarHome,
  setEmployeeWelfareList,
  setTeamWorkingCount,
  setTeamWorkingDetail,
  setTeamVisaWorkPermit,
} = employeeSlice.actions;
export default employeeSlice.reducer;
